import { isAvailable } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";

import { ECategoryLeadersMetricType } from "../category-leaders/CategoryLeaders.types";

const isHideSidebarLockedFeaturesTest = false; // TODO: remove this when cleanup lnx-87-hide-sidebar-locked-features test

const withCategoryLeadersLock = <T extends { id: ECategoryLeadersMetricType; titleKey: string }>(tab: T) => ({
    ...tab,
    get isLocked() {
        return !isAvailable(swSettings.components["CategoryLeaders"]);
    },
});

export const TABS = [
    { id: ECategoryLeadersMetricType.CategoryLeadersAll, titleKey: "common.marketing.channels.all", isLocked: false },
    withCategoryLeadersLock({
        id: ECategoryLeadersMetricType.CategoryLeadersSearch,
        titleKey: "common.marketing.channels.search",
    }),
    withCategoryLeadersLock({
        id: ECategoryLeadersMetricType.CategoryLeadersSocial,
        titleKey: "common.marketing.channels.social",
    }),
    withCategoryLeadersLock({
        id: ECategoryLeadersMetricType.CategoryLeadersAds,
        titleKey: "common.marketing.channels.ads",
    }),
    withCategoryLeadersLock({
        id: ECategoryLeadersMetricType.CategoryLeadersReferrals,
        titleKey: "common.marketing.channels.referrals",
    }),
    withCategoryLeadersLock({
        id: ECategoryLeadersMetricType.CategoryLeadersDirect,
        titleKey: "common.marketing.channels.direct",
    }),
    withCategoryLeadersLock({
        id: ECategoryLeadersMetricType.CategoryLeadersMail,
        titleKey: "common.marketing.channels.email",
    }),
    withCategoryLeadersLock({
        id: ECategoryLeadersMetricType.CategoryLeadersGenAi,
        titleKey: "common.marketing.channels.genai",
    }),
    withCategoryLeadersLock({
        id: ECategoryLeadersMetricType.CategoryLeadersAffiliates,
        titleKey: "common.marketing.channels.affiliates",
    }),
].filter((tab) => (isHideSidebarLockedFeaturesTest ? !tab.isLocked : true));
